import { render } from "./ChineseAskingDialog.vue?vue&type=template&id=76bca285&scoped=true"
import script from "./ChineseAskingDialog.vue?vue&type=script&lang=js"
export * from "./ChineseAskingDialog.vue?vue&type=script&lang=js"

import "./ChineseAskingDialog.vue?vue&type=style&index=0&id=76bca285&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bca285"]])

export default __exports__